import "./index.less";
import arrowRightImg from "../../assets/arrow_right.png";
import popupCloseImg from "../../assets/popup_close.png";
import { processOssImage } from "@xp-design/mobile/lib/utils/oss-process-image";

interface Props {
  show: boolean;
  onClose: () => void;
  onClick?: () => void;
  imgUrl: string;
  text?: string;
}

const FullScreenPopup = ({
  show,
  onClose,
  onClick = () => {},
  imgUrl,
  text = "",
}: Props) => {
  return (
    <div className={`full-screen-popup ${show ? "show" : ""}`}>
      <div className="full-screen-popup__mask"></div>
      <div className="full-screen-popup__content">
        <div className="wrap" onClick={onClick}>
          {imgUrl ? (
            <img
              src={imgUrl ? processOssImage(imgUrl) : ""}
              alt=""
              className="img"
            />
          ) : null}
          {text ? (
            <div className="desc">
              <div className="text">{text}</div>
              <img
                alt=""
                className="icon"
                src={processOssImage(arrowRightImg)}
              />
            </div>
          ) : null}
        </div>
        <img
          className="close"
          alt=""
          src={processOssImage(popupCloseImg)}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default FullScreenPopup;
